import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-archive-item',
  templateUrl: './archive-item.component.html',
  styleUrls: ['./archive-item.component.scss']
})
export class ArchiveItemComponent {
@Input() newsData?:any
}
